/*
* 问卷分组
* */
const QUESTIONNAIRE_GROUPING = {
  NO_GROUP: 0, // 未分组
  OVERALL_RATING: 1, // 总体评分
  PROCESSES: 2, // 入院与出院流程,
  CARE_FROM_NURSES: 3, // 护理服务
  CARE_FROM_DOCTORS: 4, // 医生服务
  FES: 5, // 环境、设施和服务
  OTHER_ASPECTS: 6 // 其他方面
}
const EPISODE_TYPE = {
  OP: 1, // (1, "OP", "门诊"),
  IP: 2, // (2, "IP", "住院"),
  HA: 3, // (3, "HA", "体检");
  OPO: 5 // (5, "OPO", "门诊手术"),
}
const SATISFACTIONSTATUS = {
  ALREADY_EVALUATED: 1, // 评价完
  NOT_EVALUATED: 0 // 未评价
}
const NURSINGGROUP = {
  BASICSERVICES: 7, // 基本服务
  PAINMANAGEMENT: 8 // 疼痛管理
}
export { QUESTIONNAIRE_GROUPING, SATISFACTIONSTATUS, EPISODE_TYPE, NURSINGGROUP }
